import { useCallback, useRef } from 'react';
import { useAuth } from '@hooks/useAuth';
import { combineUserName } from '@helpers/combineUserName';
import UserAvatarLetters from '@helpers/userAvatarLetters';
import { useAssetViewerState } from '@hooks/useAssetViewerState';

export default function useUserPicture() {
  const { user } = useAuth();
  const { commentsList } = useAssetViewerState();

  const userRef = useRef(user);
  userRef.current = user;

  const commentsListRef = useRef(commentsList);
  commentsListRef.current = commentsList;

  const setMyPicture = useCallback(() => {
    const user = userRef.current;
    if (!user) return { name: '', userId: '', email: '' };
    const { id, email } = user;
    const alt = UserAvatarLetters(combineUserName(user));
    return { name: alt, email, userId: id };
  }, []);

  const getUserPicture = useCallback((commentId: string) => {
    const commentsList = commentsListRef.current;
    const comment = commentsList.find((it) => it.id === commentId);
    if (!comment?.user) return { name: '', email: '', userId: '' };
    const { email, id } = comment.user;
    const alt = UserAvatarLetters(combineUserName(comment.user));
    return { name: alt, email, userId: id };
  }, []);

  return { setMyPicture, getUserPicture };
}
